import { IBreadcrumbItem } from '@bfe/moly/dist/es/Breadcrumb';

import Bread from '../Bread';
import { PageLevel } from '.';

interface IProps {
  pageLevel: PageLevel;
  pageTitle?: string;
  breadItems?: IBreadcrumbItem[];
}

const PageHeader = ({ pageLevel, pageTitle, breadItems }: IProps) => {
  return (
    <>
      {pageLevel === PageLevel.main && (
        <div className="page-header">
          {pageTitle && <h3 className="page-title">{pageTitle}</h3>}
        </div>
      )}
      {pageLevel === PageLevel.sub && breadItems && breadItems.length > 0 && (
        <div className="sub-page-header">
          <Bread items={breadItems} />
        </div>
      )}
    </>
  );
};

export default PageHeader;
